import { Outlet, useLocation } from "react-router-dom";
import Header from "../partials/Header";
import Footer from "../partials/Footer";
import useTabActivityMessage from "../../hooks/usePageMetaTags";
import { useEffect } from "react";
import OrderReceiveModal from "./OrderReceiveModal";
import { useNotification } from "../../context/NotificationContext";

const POOLING_TIME = 10 * 60 * 1000;

const DashboardLayout = () => {
  const { fetchOrders } = useNotification();

  useTabActivityMessage();
  const location = useLocation();

  const toggleFullScreen = () => {
    const doc = document;
    const docEl = document.documentElement;

    if (
      !doc.fullscreenElement &&
      !doc.webkitFullscreenElement &&
      !doc.msFullscreenElement
    ) {
      if (docEl.requestFullscreen) {
        docEl.requestFullscreen();
      } else if (docEl.webkitRequestFullscreen) {
        docEl.webkitRequestFullscreen();
      } else if (docEl.msRequestFullscreen) {
        docEl.msRequestFullscreen();
      }
    } else {
      if (doc.exitFullscreen) {
        doc.exitFullscreen();
      } else if (doc.webkitExitFullscreen) {
        doc.webkitExitFullscreen();
      } else if (doc.msExitFullscreen) {
        doc.msExitFullscreen();
      }
    }
  };

  useEffect(() => {
    const btn = document.getElementById("btnFullscreen");
    if (btn) {
      btn.addEventListener("click", toggleFullScreen);
    }

    return () => {
      if (btn) {
        btn.removeEventListener("click", toggleFullScreen);
      }
    };
  }, []);

  useEffect(() => {
    fetchOrders(); // 🔥 first call after header mount

    const interval = setInterval(fetchOrders, POOLING_TIME);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const el = document.querySelector(".main-wrapper");
    const so = document.querySelector(".sidebar-overlay");
    if (el) {
      el.classList.remove("slide-nav");
      so.classList.remove("opened");
    }
  }, [location.pathname]);

  return (
    <>
      <Header />
      <div className="page-wrapper">
        <Outlet />
        <Footer />
      </div>

      {/* <OrderReceiveModal /> */}
    </>
  );
};

export default DashboardLayout;
